import { setStoreValue } from "@/store/utils";

export const SET_IS_FETCHING_APPLICATION_QUESTION_TEMPLATES =
  "SET_IS_FETCHING_APPLICATION_QUESTION_TEMPLATES";
export const SET_ORGANISATION_APPLICATION_QUESTION_TEMPLATES =
  "SET_ORGANISATION_APPLICATION_QUESTION_TEMPLATES";

const mutations = {
  [SET_IS_FETCHING_APPLICATION_QUESTION_TEMPLATES]: setStoreValue(
    "isFetchingOrganisationApplicationQuestionTemplates"
  ),
  [SET_ORGANISATION_APPLICATION_QUESTION_TEMPLATES]: setStoreValue(
    "organisationApplicationQuestionTemplates"
  )
};

const state = {
  organisationApplicationQuestionTemplates: [],
  isFetchingOrganisationApplicationQuestionTemplates: false
};

export { mutations, state };
